import React, { useReducer } from 'react';

export default function(initialState: object) {
    return useReducer((prev, payload) => ({ ...prev, ...payload }), initialState);
}
